export function convertToLocalDate(dateString: string): string {
    const isUTCDate = /^\d{4}-\d{2}-\d{2}$/.test(dateString); //YYYY-MM-DD this format string considered as UTC
    if(isUTCDate){
        return dateString + "T00:00:00"; //this will create as local date
    }

    return dateString;
}
